import { useGetProcessesFilterSuggestions } from 'gcs-common/clients/api/entities/processes/processes-api';
import type { FetchProcessesFilterSuggestionsData } from 'gcs-common/clients/api/entities/processes/processes-api-helpers';
import Alert from 'gcs-common/components/Alert/Alert';
import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import { PROCESSES_SUGGESTION_TYPE } from 'gcs-common/constants/processesSuggestionType';
import { getChannelOPUserId, getPrimaryHouseForChannel } from 'gcs-common/slices/channel/channelSelectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getProcessSearchInput } from 'gcs-common/slices/processes/processesSelectors';
import { suggestionSelected } from 'gcs-common/slices/processes/processesSlice';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';

const SuggestionList = () => {
  const searchInput = useSelector(getProcessSearchInput);
  const selectedChannelId: string = useSelector(getSelectedChannelId);
  const channelOpUserId: string = useSelector(getChannelOPUserId(selectedChannelId));
  const houseId: string = useSelector(getPrimaryHouseForChannel(selectedChannelId));
  const isAgent: boolean = useSelector(getIsAgent);

  const {
    data: suggestions,
    isFetching: suggestionsLoading,
    error,
  } = useGetProcessesFilterSuggestions({
    query: {
      house_id: houseId,
      user_id: isAgent ? channelOpUserId : undefined,
      query_string: searchInput,
    },
  });

  const dispatch = useDispatch();

  const selectSuggestion = (suggestion: FetchProcessesFilterSuggestionsData[number]) => {
    dispatch(suggestionSelected({ suggestion }));
  };

  if (suggestionsLoading) {
    return <LoadingIndicator key="loading-indicator" />;
  }

  if (error) {
    return (
      <div className={styles.errorMessage}>
        <Alert type="info">
          <p className={styles.errorMessageText}>{error.message}</p>
        </Alert>
      </div>
    );
  }

  if (searchInput.length > 0 && (!suggestions || suggestions.length <= 0)) {
    return <div className={styles.errorMessage}>{`Keine Vorschläge für die Suche nach '${searchInput}'.`}</div>;
  }

  return (
    <div className={styles.suggestionList}>
      {suggestions?.map((suggestion) => (
        <button
          type="button"
          onClick={() => selectSuggestion(suggestion)}
          className={styles.suggestionItem}
          key={`${suggestion.Suggestion}-${suggestion.Type}-${suggestion.ProcessNumber}`}
        >
          <div className={styles.suggestion}>{suggestion.Suggestion}</div>
          <div className={styles.suggestionType}>{PROCESSES_SUGGESTION_TYPE[suggestion.Type]}</div>
        </button>
      ))}
    </div>
  );
};

export default SuggestionList;
